module.exports = __webpack_public_path__ + "img/w43b.24e4fdb6.jpg";